import { getMessages } from '../../../../../../../store/constants';

export const COLOR_TAGS_SEARCH_SCROLL_TIMEOUT = 600;
export const COLOR_TAGS_SEARCH_SCROLL_UP_HINT = getMessages().getText('kanban.color_tags.hint');
